import React from "react";
import VideoThumbnail from 'react-video-thumbnail';
import "../styles.css"
const VideoListItem = (props) => {
    return (
        // <div className="vlVideoContainer brdrTop">
        //     <div className="vlVideoHdngRow">
        //         <span className="vlVideoHdngtxt">{l.vid_list}</span>
        //     </div>
        //     <div className="vlWrapper">
        //         <div className="vlVideoItem">
        //             <div className="vlVideoBox">
        //                 <iframe src={props.data.url} title={props.data.uploadkey} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        //             </div>
        //         </div>
        //     </div>
        // </div>
        <div className="wcVdoBoxItem" onClick={props?.openVideoModal}>
        {/* <div className="wvVdoCover"></div> */}
        <div className="wcVdoBox16x9 topicCardBg">
            {props?.data?.uploadtype === 'youtubeUrl'  ? 
            <>
             <div className="videoThumbOverlay"></div>   
             <img src={`https://img.youtube.com/vi/${props?.data?.url?.split('=')[1] ? props?.data?.url?.split('=')[1] : props?.data?.url?.split('/')[4]}/hqdefault.jpg`} alt="thumbnail" />
            </> : 
            <><div className="videoThumbOverlay"></div>
                <VideoThumbnail
                    videoUrl={props?.data?.url} /></>
                }
            {/* <iframe src={props.data.url} title={props.data.uploadkey} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> */}
        </div>
        <div className="wcVdoHdngBox">
            {/* <span className="wcVdoHdng">{props.label}</span> */}
        </div>
    </div>
    )
}
export default VideoListItem;